import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7beb4e35"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "steps" }
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = { class: "title" }

import { ref, watch } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: ['steps', 'modelValue'],
  setup(__props) {

const props = __props

const active = ref(0)

watch(
  () => props.modelValue,
  () => {
    const values = props.steps.map((item: any) => item.value)
    active.value = values.indexOf(props.modelValue)
  },
  {
    deep: true,
    immediate: true,
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.steps, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["step", { active: index <= active.value }])
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(Number(index + 1)), 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(item.title), 1),
        _createElementVNode("span", {
          class: _normalizeClass(["line", { 'active-line': index < active.value }])
        }, null, 2)
      ], 2))
    }), 128))
  ]))
}
}

})